var stickyHeader = (function() {

    var offset = 100;

    function onScroll($containerElement) {

        scroll = $(window).scrollTop();

        if (scroll >= offset) {
            $containerElement.addClass('fixed');
        } else {
            $containerElement.removeClass('fixed');
        }
    };

    return {
        onScroll: onScroll
    }
})();
